import React, { useState } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Project-view/preojectview.css";

const Projectview = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  return (
    <>
      <div className="g-sidenav-show bg-gray-100 min-vh-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar} handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />
            <div>
              <div className="header header-bg pb-6">
                <div className="container-fluid">
                  <div className="header-body">
                    <div className="row align-items-center py-4">
                      <div className="col-lg-6 col-7">
                        <nav
                          aria-label="breadcrumb"
                          className="d-none d-md-inline-block ml-md-4"
                        >
                          <ol
                            className="breadcrumb breadcrumb-links breadcrumb-dark"
                            style={{ background: "transparent" }}
                          >
                            <li className="breadcrumb-item">
                              <Link to="/dashboard">
                                <i className="fas fa-home" />
                              </Link>
                            </li>
                            <li className="breadcrumb-item mt-2">
                              <Link to="/projects" style={{ textDecoration: "none",fontSize:"15px" }}>
                                Projects
                              </Link>
                            </li>
                            <li className="breadcrumb-item mt-2">
                              <span className="" style={{ color: "#f6f9fc" }}>
                                View Project
                              </span>
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="container-fluid mt--6">
                <div className="row">
                  <div className="col">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="container-fluid">
                          <div className="row align-items-center mb-4">
                            <div className="col-md-8">
                              <h6 className="mb-0 font-weight-bold">Project: Redesign Company Website</h6>
                              <p className="text-muted small mb-0 mt-1">Project ID: <strong>#PRJ-1023</strong></p>
                              <span className="badge badge-success mt-2">In Progress</span>
                            </div>
                          </div>

                          <hr />

                          <div className="row">
                            <div className="col-md-6 mb-4">
                              <h6 className="text-uppercase projectdetails-title">Client</h6>
                              <p className="mb-1 text-muted">Acme Corporation</p>
                              <h6 className="text-uppercase mt-4 projectdetails-title">Start Date</h6>
                              <p className="mb-0 text-muted">April 15, 2025</p>
                            </div>

                            <div className="col-md-6 mb-4">
                              <h6 className="text-uppercase projectdetails-title">Project Manager</h6>
                              <p className="mb-1 text-muted">Jane Doe</p>
                              <h6 className="text-uppercase mt-4 projectdetails-title">Deadline</h6>
                              <p className="mb-0 text-muted">July 30, 2025</p>
                            </div>
                          </div>

                          <div className="row mt-4">
                            <div className="col-12">
                              <h6 className="text-uppercase projectdetails-title">Description</h6>
                              <p className="project-descp text-muted">
                                The project involves a complete redesign of the company’s public-facing website to
                                improve brand identity, mobile responsiveness, and SEO performance.
                              </p>
                            </div>
                          </div>

                          <div className="row mt-4">
                            <div className="col-md-4 mb-3">
                              <div className="bg-light p-3 rounded shadow-sm h-100">
                                <h6 className="projectdetails-title">Budget</h6>
                                <h6 className="text-muted project-descp">$25,000</h6>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <div className="bg-light p-3 rounded shadow-sm h-100">
                                <h6 className=" projectdetails-title">Tasks Completed</h6>
                                <h6 className="text-muted project-descp">12 / 20</h6>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <div className="bg-light p-3 rounded shadow-sm h-100">
                                <h6 className=" projectdetails-title">Team Size</h6>
                                <h6 className="text-muted project-descp">5 Members</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default Projectview;
